import React from "react";
import { Link, navigate, Redirect } from "@reach/router";
import { signInWithGoogle } from "../../auth/signInWithGoogle";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Button, Divider } from "@material-ui/core";
import { FcGoogle } from "react-icons/fc";
import BackgroundWrapper from "../base/BackgroundWrapper";
import HeartLogo from "../HeartLogo.jsx";
import Div100vh from "@rodmg/react-div-100vh";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    height: "100%",
    padding: theme.spacing(2.5),
    boxSizing: "border-box",
    color: theme.palette.grey[100],
    display: "flex",
    alignItems: "stretch",
  },
  contentContainer: {
    zIndex: "1",
    display: "flex",
    height: "100%",
    width: "100%",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  title: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  selection: {
    marginBottom: theme.spacing(5),
  },
  button: {
    marginBottom: theme.spacing(1),
  },
  linkBlack: {
    color: theme.palette.common.black,
  },
  linkWhite: {
    color: theme.palette.common.white,
  },
  divider: {
    background: theme.palette.grey[600],
    margin: theme.spacing(4, 10, 1.5, 10),
  },
}));

function Home({ authenticated }) {
  const classes = useStyles();

  const onSignInWithGoogleClicked = async () => {
    const signInSuccessful = await signInWithGoogle();
    if (signInSuccessful) {
      navigate("/stationen");
    }
  };

  if (authenticated) {
    return <Redirect to="/stationen" noThrow />;
  }

  return (
    <BackgroundWrapper>
      <Div100vh>
        <div className={classes.wrapper}>
          <div className={classes.contentContainer}>
            <div className={classes.title}>
              <HeartLogo white thick />
              <Typography variant="h3">
                <strong>Fitness Trail</strong>
              </Typography>
              <Typography variant="h5">Mosbach</Typography>
            </div>
            <div className={classes.selection}>
              <Link to="/sign-in" className={classes.linkBlack}>
                <Button
                  variant="contained"
                  color="inherit"
                  fullWidth={true}
                  className={classes.button}
                >
                  Anmelden
                </Button>
              </Link>
              <Button
                variant="outlined"
                fullWidth={true}
                startIcon={<FcGoogle />}
                color="inherit"
                onClick={onSignInWithGoogleClicked}
                className={classes.button}
              >
                Weiter mit Google
              </Button>
              <div align="center">
                <Divider className={classes.divider} />
                <Link to="/create-account" className={classes.linkWhite}>
                  <Typography variant="subtitle2">
                    Du hast noch keinen Account? REGISTRIEREN
                  </Typography>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </Div100vh>
    </BackgroundWrapper>
  );
}

export default Home;
